import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import moment from "moment";
import Notiflix from "notiflix";
import PostApiCall from "./Api";
import login from "./assets/img/banner/login.png";
import borderimg from "./assets/img/banner/border.png";
import { isMobile } from "react-device-detect";
import { AiFillEyeInvisible } from "react-icons/ai";
import { store } from "./context/store";
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

class GoogleLoginComponent extends React.Component {
	static contextType = store;

	constructor(props) {
		super(props);
		this.state = {
			NumRegex: /^[0-9]*$/,
			AlphaNumericRegex: /^[a-zA-Z0-9]*$/,
			EmailRegex:
				/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			UrlRegex:
				/^(https:\/\/www\.|httpss:\/\/www\.|https:\/\/|httpss:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
			open: false,
			Email: "",
			openOtp: false,
			Salt: [],
			Name: "",
			MobileNo: "",
			EmailAddress: "",
		};
	}

	componentDidMount() {
		Notiflix.Loading.Init({
			svgColor: "#0f3d74",
		});

		const store = this.context;
	}


	handleLogin = (response) => {
		if (response?.credential) {
			// console.log('Google Login Success:', response);
			const userInfo = jwtDecode(response?.credential);
			var Order = localStorage.getItem("OrderData");
			var Orderdetails = JSON.parse(Order);
			Notiflix.Loading.Circle();
			PostApiCall.postRequest(
				{
					name: userInfo.name,
					mobile: null,
					email: userInfo.email,
					cartid:
						localStorage?.getItem("OrderData") == null
							? null
							: Orderdetails[0].order_id,
					signupguest: "Continue",
				},
				"AddGuest"
			).then((results) =>
				results.json().then((obj) => {
					if (
						(results.status == 200 || results.status == 201) &&
						localStorage.getItem("OrderData")
					) {
						localStorage.setItem("CustomerData", JSON.stringify(obj.data));
						localStorage.setItem("access", JSON.stringify(obj.data[0].fld_salt));
						Notiflix.Loading.Remove();
						this.onPostMoveCart(obj);
					} else if (results.status == 200 || results.status == 201) {
						Notiflix.Loading.Remove();
						localStorage.setItem("CustomerData", JSON.stringify(obj.data));
						localStorage.setItem("access", JSON.stringify(obj.data[0].fld_salt));
						// this.addToCart();
						if (localStorage.getItem("currentPage") != null) {
							localStorage.getItem("currentPage") == "Cart"
								? (window.location.href = "/select_address")
								: (window.location.href = "/");
						} else {
							localStorage.getItem("ReviewPage") == "ReviewPage"
								? this.props.history.goBack()
								: (window.location.href = "/");
						}
					} else {
						Notiflix.Loading.Remove();
						Notiflix.Notify.Failure(obj.data);
					}
				})
			);
		};
	}

	onPostMoveCart(obj) {
		//console.log('move to cart')
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);

		Notiflix.Loading.Circle();

		PostApiCall.postRequest(
			{
				customerid: JSON.stringify(obj.data[0].fld_customerid),
				cartid: Orderdetails[0].order_id,
			},
			"MoveTmpCrtToMain"
		).then((results) =>
			// const objs = JSON.parse(result._bodyText)
			results.json().then((obj) => {
				if (results.status == 200 || results.status == 201) {
					localStorage.removeItem("OrderData");
					Notiflix.Loading.Remove();
					if (localStorage.getItem("currentPage") != null) {
						localStorage.getItem("currentPage") == "Cart"
							? (window.location.href = "/select_address")
							: (window.location.href = "/");
					} else {
						localStorage.getItem("ReviewPage") == "ReviewPage"
							? this.props.history.goBack()
							: (window.location.href = "/");
					}
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Failure(obj.data);
				}
			})
		);
	}
	addToCart() {
		var login = localStorage.getItem("CustomerData");
		var logindetails = JSON.parse(login);
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);

		var itemdetail = JSON.parse(localStorage.getItem("itemdetails"));
		// console.log(itemdetail)
		PostApiCall.postRequest(
			{
				orderdate: moment().format("lll"),
				itemdetails: `
                                          [
                                          { 
                                              "Item":${itemdetail[0]?.Item},
                                              "Quantity":${1}
                                          }
                                          ]
                                          `,
				status: "INCART",
				customerid:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_customerid,
				createdon: moment().format("lll"),
				updatedon: moment().format("lll"),
				orderid:
					localStorage.getItem("OrderData") == null
						? 0
						: Orderdetails[0].order_id,
				updatedby:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_userid,
			},
			"AddToCartWebsite"
		).then((result) =>
			result.json().then((obj) => {
				if (result.status == 200 || result.status == 201) {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Success("Product added to Cart.");
					// console.log(obj.data)
					if (localStorage.getItem("OrderData") == null) {
						//console.log('datastore')
						localStorage.setItem("OrderData", JSON.stringify(obj.data));
						this.getCartdetails();
					}
					this.getCartdetails();
					// window.location.reload();
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.failure(obj.data);
				}
			})
		);
	}
	getCartdetails = () => {
		Notiflix.Loading.Circle();
		var login = localStorage.getItem("CustomerData");
		var logindetails = JSON.parse(login);

		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);

		// console.log('cart')
		PostApiCall.postRequest(
			{
				orderid:
					localStorage.getItem("OrderData") == null
						? null
						: Orderdetails[0].order_id,
				id:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_customerid,
			},
			"GetCartWebsite"
		)
			.then((res) => res.json())
			.then((res1) => {
				if (res1.data) {
					Notiflix.Loading.Remove();

					// localStorage.setItem('CardCount', JSON.stringify(res1.data.length))

					this.setState({
						ProductCart: res1.data,
					});

					this.context.setcart(res1.data.length);
					this.context.setcartamount(res1.data[0].fld_cart_amount_preview);

					// console.log(this.context)
					if (localStorage.getItem("currentPage") != null) {
						localStorage.getItem("currentPage") == "Cart"
							? (window.location.href = "/select_address")
							: (window.location.href = "/");
					} else {
						localStorage.getItem("ReviewPage") == "ReviewPage"
							? this.props.history.goBack()
							: (window.location.href = "/");
					}
				}
			});
	};
	handleFailure = (error) => {
		console.error('Google Login Failed:', error);
	};

	render() {
		// console.log(this.context.currentPage)
		return (
			<div className="w-100 text-center">
				<GoogleLogin
					onSuccess={this.handleLogin.bind(this)}
					onError={this.handleFailure.bind(this)}
					text='continue_with'
					logo_alignment='center'
				/>
			</div>
		);
	}
}

export default GoogleLoginComponent;
